import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export type ObscuredProps = IconProps & {
  bgCircle?: boolean
};

export const Obscured = ({
  width = 32,
  height = 32,
  className,
  color,
  decorative = false,
  ariaLabel = "Hide",
  fillColor = "#2F475E",
  bgCircle = true,
}: ObscuredProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 32 32"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      {bgCircle && <circle cx="16" cy="16" r="16" fill="#EBECED"></circle>}
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="m12.5 24.3 6.1-16.9.9.3-6.1 16.9zM7.1 16a9.8 9.8 0 0 1 8.9-5.5h.4l.4-.9H16a10.9 10.9 0 0 0-9.8 6L6 16l.2.5a11 11 0 0 0 6.1 5.3l.3-.9A9.8 9.8 0 0 1 7.1 16M19 16a3.2 3.2 0 0 0-.7-1.9l.4-1.1a4.2 4.2 0 0 1 1.3 3 4 4 0 0 1-3.9 4l.4-1.1A2.9 2.9 0 0 0 19 16m.7-5.8a11 11 0 0 1 6.1 5.3l.2.5-.2.4a10.9 10.9 0 0 1-9.8 6h-.8l.4-.9h.4a9.8 9.8 0 0 0 8.9-5.5 9.8 9.8 0 0 0-5.5-4.9zm-4.2 2.9.4-1.1a4 4 0 0 0-3.9 4 4.2 4.2 0 0 0 1.3 3l.4-1.1A3.2 3.2 0 0 1 13 16a2.9 2.9 0 0 1 2.5-2.9"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
